<template>
  <div class="first-box">
    <el-form ref="baseFormRef" class="goods-form" :disabled="isReadOnly" :rules="baseFormRules" :model="baseForm"
      label-width="128px">
      <item-box class="base-info">
        <template v-slot:title>基本信息</template>
        <template v-slot:content>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input placeholder="请输入商品名称(最多22个字符)" maxlength="22" v-model.trim="baseForm.goodsName"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="商品描述" prop="goodsDescription">
            <el-input placeholder="请输入商品描述" v-model.trim="baseForm.goodsDescription" clearable></el-input>
          </el-form-item>
          <el-form-item label="商品编号" prop="goodsSn">
            <div class="box flex-c-s">
              <el-input maxlength="16" :disabled="isReadOnly || unEditSku || isGetGoodsSn"
                placeholder="请输入商品编号(最多16个字符)" v-model.trim="baseForm.goodsSn" clearable></el-input>
              <el-button v-if="!isReadOnly && !unEditSku" :disabled="isGetGoodsSn" class="get-button"
                @click="handleGetGoodsSn" type="primary" size="mini">系统生成</el-button>
              <el-tooltip effect="dark" content="注意：商品入库后，商品编号将不可编辑！" placement="top">
                <i class="tips-icon el-icon-question"></i>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item label="商品分类" prop="categoryId">
            <div class="box flex-c-s">
              <el-cascader aria-hidden="false" :disabled="isReadOnly || unEditSku" placeholder="请选择商品分类" :options="categoryData" :props="props" clearable
                v-model="baseForm.categoryId" @change="handleCategoryChange"></el-cascader>
              <el-tooltip effect="dark" :content="`注意：${unEditSku ? '商品入库后，商品分类将不可编辑；' : '重新选择商品分类后将重置品牌、参数配置及规格配置;'}`" placement="top">
                <i class="tips-icon el-icon-question"></i>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item v-if="baseForm.categoryId && brandList.length > 0" label="商品品牌" prop="brandId">
            <el-select placeholder="请选择商品品牌" v-model="baseForm.brandId" clearable>
              <el-option v-for="item in brandList" value-key="brandId" :key="item.brandId" :label="item.brandName"
                :value="item.brandId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品保质期" prop="qualityGuaranteePeriod">
            <div class="box flex-c-s">
              <el-input placeholder="请输入商品保质期" @blur="handleValidate('qualityGuaranteePeriodWarning')"
                v-model.trim="baseForm.qualityGuaranteePeriod" clearable>
                <template slot="append">天</template>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label="保质期预警" prop="qualityGuaranteePeriodWarning">
            <div class="box flex-c-s">
              <el-input placeholder="请输入保质期预警" @blur="handleValidate('qualityGuaranteePeriod')"
                v-model.trim="baseForm.qualityGuaranteePeriodWarning" clearable>
                <template slot="append">天</template>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label="商品图片" prop="goodsImgsList">
            <xiaobu-upload-img :disabled="isReadOnly" :openCropper="true" @imgChange="handleImgChange" :max="9"
              :imgList="baseForm.goodsImgsList"></xiaobu-upload-img>
          </el-form-item>
        </template>
      </item-box>
      <div class="control-box flex-c-c">
        <el-button type="primary" plain :disabled="false" @click="$router.back()">返 回</el-button>
        <el-button type="primary" :disabled="false" @click="goNext">下一步</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import XiaobuUploadImg from "@/components/upload-img/index.vue"
import { categoryApi, goodsApi } from "@/api"
import { getPathByTreeValue } from "vue2-element-admin-plugin"
import { positiveIntegerReg } from "@/utils/check-reg"
export default {
  components: {
    XiaobuUploadImg
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => { return {} }
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    unEditSku: {
      type: Boolean,
      default: false
    }
  },
  data() {
    /** 检查是否已存在 */
    const checkGoodsName = (rule, value, callback) => {
      goodsApi.judgeGoodsNameExist({ goodsName: value, goodsId: this.baseForm.goodsId }).then((data) => {
        if (data.validateResult) {
          callback()
        } else {
          callback(data.msg)
        }
      })
    }

    const checkGoodsSn = (rule, value, callback) => {
      /*
         系统生成的不校验  新增和编辑时 isGetGoodsSn 为true 则表示 系统生产的 
         编辑时 value 等于旧编号时 也不校验 说明没改动 
      */
      if (this.isGetGoodsSn || value === this.oldGoodsSn) {
        callback()
        return
      }
      const regex = /^\d+$/
      if (!regex.test(value)) {
        callback("商品编号仅支持输入数字")
        return
      }
      goodsApi.judgeGoodsSnExist({ goodsSn: value, goodsId: this.baseForm.goodsId }).then((data) => {
        if (data.validateResult) {
          callback()
        } else {
          callback(data.msg)
        }
      })
    }

    // 校验过期预警
    const checkQualityGuaranteePeriodWarning = (rule, value, callback) => {
      if (!value) {
        callback("请输入商品保质期预警")
        return
      }
      if (!positiveIntegerReg.test(value)) {
        callback("请输入正确的商品保质期预警")
        return
      }
      if (!this.baseForm.qualityGuaranteePeriod) {
        callback()
      } else if (Number(this.baseForm.qualityGuaranteePeriod) <= Number(value)) {
        callback("商品保质期预警必须小于商品保质期")
      } else {
        callback()
      }
    }

    const checkQualityGuaranteePeriod = (rule, value, callback) => {
      if (!value) {
        callback("请输入商品保质期")
        return
      }
      if (!positiveIntegerReg.test(value)) {
        callback("请输入正确的商品保质期")
        return
      }
      if (!this.baseForm.qualityGuaranteePeriodWarning) {
        callback()
      } else if (Number(this.baseForm.qualityGuaranteePeriodWarning) >= Number(value)) {
        callback("商品保质期必须大于商品保质期预警")
      } else {
        callback()
      }
    }
    return {
      oldGoodsSn: "", // 编辑前的商品编号
      isGetGoodsSn: false, // 是否点击了 系统生成商品编号
      hasGet: false, // 详情时 已经获取过分类相关数据
      baseForm: {
        goodsId: null, // 商品ID
        goodsName: "",
        goodsDescription: "", // 商品描述
        goodsSn: "",
        categoryId: "",
        brandId: "",
        qualityGuaranteePeriod: "", // 商品保质期
        qualityGuaranteePeriodWarning: "", // 商品保质期预警
        goodsImgsList: []
      },
      baseFormRules: {
        goodsName: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
          { validator: checkGoodsName, trigger: "blur" }
        ],
        goodsDescription: [
          { required: true, message: "请输入商品描述", trigger: "blur" }
        ],
        goodsSn: [
          { required: true, message: "请输入商品编号", trigger: "blur" },
          { validator: checkGoodsSn, trigger: "blur" }
        ],
        categoryId: [
          { required: true, message: "请选择商品分类", trigger: "change" }
        ],
        qualityGuaranteePeriod: [
          { required: true, validator: checkQualityGuaranteePeriod, trigger: "blur" }
        ],
        qualityGuaranteePeriodWarning: [
          { required: true, validator: checkQualityGuaranteePeriodWarning, trigger: "blur" }
        ],
        goodsImgsList: [
          { required: true, message: "请上传商品图片", trigger: "change" }
        ]
      },
      props: {
        value: "categoryId",
        label: "categoryName",
        checkStrictly: true,
        emitPath: false
      },
      brandList: [], // 品牌数据
      categoryData: [] // 分类数据
    }
  },
  watch: {
    detailInfo: {
      handler: function(val) {
        // 获取分类对应的数据
        if (this.categoryData.length > 0 && !this.hasGet) {
          this.hasGet = true
          this.getCategoryDatas(val)
        }
        Object.keys(this.baseForm).forEach(key => {
          this.baseForm[key] = val[key]
        })
        // 记录旧商品编号 解决 编辑时 会校验的问题
        this.oldGoodsSn = val.goodsSn
        this.baseForm.goodsImgsList = val.goodsImgs.split(",").map(item => {
          return {
            url: item,
            name: "商品图片.jpg"
          }
        })
      }
    }
  },
  async created() {
    // 初始化 获取相应的数据
    await this.init()
  },
  methods: {
    handleValidate(field) {
      // 没有值时不校验
      if (!this.baseForm[field]) { return }
      this.$refs.baseFormRef && this.$refs.baseFormRef.validateField(field)
    },
    // 获取商品编号
    handleGetGoodsSn() {
      goodsApi.generateGoodsSn().then(data => {
        this.baseForm.goodsSn = data.goodsSn
        this.isGetGoodsSn = true // 系统获取商品编号 设置为true
        this.$refs.baseFormRef && this.$refs.baseFormRef.validateField("goodsSn")
      })
    },
    // 初始化
    init() {
      // 获取商品分类
      return categoryApi.getCategoryTree().then((data) => {
        this.categoryData = data
        if (this.detailInfo.categoryId && !this.hasGet) {
          this.hasGet = true
          this.getCategoryDatas(this.detailInfo)
        }
      })
    },
    // 获取分类对应的品牌、规格参数
    getCategoryDatas(val) {
      this.handleCategoryChange(val.categoryId)
      if (val.brandId) {
        this.baseForm.brandId = val.brandId
      }
    },
    // 分类改变事件
    handleCategoryChange(val) {
      this.baseForm.brandId = ""
      this.baseForm.groupJson = ""

      if (!val) {
        this.baseForm.categoryId = ""
        this.$emit("categoryChange", { categoryId: "", groupJson: null })
        return
      }
      const target = getPathByTreeValue(this.categoryData, val, { targetField: "categoryId" })
      if (!target || target.length === 0) {
        this.$modal.msgError("未找到该分类信息")
        return
      }
      const resultTarget = target[target.length - 1]
      this.baseForm.categoryId = resultTarget.categoryId
      this.$emit("categoryChange", resultTarget)
      this.getBrandList(resultTarget.categoryId)
    },
    getBrandList(categoryId) {
      goodsApi.getBrandListByCategoryId({ categoryId }).then((data) => {
        this.brandList = data
      })
    },
    // 图片改变事件
    handleImgChange(goodsImgsList) {
      this.baseForm.goodsImgsList = goodsImgsList
      this.$refs.baseFormRef && this.$refs.baseFormRef.validateField("goodsImgsList")
    },
    // 下一步
    goNext() {
      this.$refs.baseFormRef && this.$refs.baseFormRef.validate(valid => {
        if (valid) {
          this.$emit("next", this.baseForm)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.first-box {
  .base-info {
    margin-top: 12px;
  }

  ::v-deep .goods-form {
    .el-form-item__content {

      .el-cascader,
      .el-select,
      .el-input {
        width: 360px !important;
      }

      .tips-icon {
        font-size: 24px;
        margin-left: 12px;
        color: $mainColor;
      }

      .get-button {
        position: absolute;
        width: 88px;
        left: calc(348px - 88px);
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

}
</style>